/**
 * ============================================
 * KONFIGURACIJA STRANICE - APARTMAN ADRIATIC
 * ============================================
 * 
 * Podaci preuzeti s Booking.com
 * Lokacija: Orebić, Hrvatska
 */

// ============================================
// OSNOVNE INFORMACIJE O APARTMANU
// ============================================
export const apartmentInfo = {
  name: "Apartmani Adriatic i Maestral",
  
  tagline: "Smještaj uz plažu u blizini Orebića s pogledom na more",
  
  description: "Apartmani Adriatic i Maestral nude smještaj uz plažu u blizini Orebića s prekrasnim pogledom na more. Gosti mogu uživati na sunčanoj terasi. Oba apartmana imaju klimu, privatne kupaonice s besplatnim priborom za higijenu i potpuno opremljene kuhinje. Dodatne pogodnosti koje posjeduju oba apartmana su terase, besplatni WiFi, smart TV, itd. Također, na raspolaganju su i privatna parking mjesta.",
  
  maxGuests: 4,
};

// ============================================
// GALERIJA SLIKA
// ============================================
export const galleryImages = [
  {
    id: 1,
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/711608846.jpg?k=38e7c9f052a4fec01557a301247526acd3d699294a29a438735ce0fdaf7a7396&o=",
    alt: "Spavaća soba s krevetom",
  },
  {
    id: 2,
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/336596920.jpg?k=aabee7a66feb29f2eaada3369057f9d108a04afb7efc9c88e4781cc8a21e2655&o=",
    alt: "Spavaća soba s stolom i stolicom",
  },
  {
    id: 3,
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/336595476.jpg?k=44643d39f39dfcf545c7507430629422108223654b1f2071638b77edd4764caa&o=",
    alt: "Kuhinja s prozorom",
  },
  {
    id: 4,
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/372083659.jpg?k=a0e23a71eb38aa0efe4ed4683fb2021ae018f36c532648033ce6329fc47e9dfb&o=",
    alt: "Dnevni boravak s stolom",
  },
  {
    id: 5,
    url: "https://cf.bstatic.com/xdata/images/hotel/max1024x768/374086698.jpg?k=975d966b5e9f54cbcd9f7e6983e816e2e3b3283fe6fd2fd672f6b2e3157c55c0&o=",
    alt: "Pogled na more s balkona",
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/5viv0xoh_Uljep%C5%A1ana%20slika%203.png",
    alt: "Dnevni boravak s plavim kaučem",
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/raqxh7ya_uljep%C5%A1ana%20slika%202.png",
    alt: "Detalji dnevnog boravka",
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/0jr4saqw_IMG-20230715-WA0007.jpg",
    alt: "Skrivena uvala",
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/oq8mp2ys_20250705_090829.jpg",
    alt: "Apartman interijer",
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/sei6hn4m_20250705_091048.jpg",
    alt: "Terasa s pogledom na more",
  },
];

// ============================================
// HERO SLIKE (izmjenjuju se)
// ============================================
export const heroImages = [
  "https://cf.bstatic.com/xdata/images/hotel/max1024x768/711608846.jpg?k=38e7c9f052a4fec01557a301247526acd3d699294a29a438735ce0fdaf7a7396&o=",
  "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/rqk2imfw_20221008_182328.jpg"
];

export const heroImage = heroImages[0];

// ============================================
// ZNAČAJKE / POGODNOSTI APARTMANA
// ============================================
export const features = [
  {
    icon: "Wifi",
    title: "Besplatni brzi WiFi",
    description: "60 Mbps bežična internet veza u cijelom apartmanu",
  },
  {
    icon: "Car",
    title: "Besplatan parking",
    description: "Osigurano besplatno parkirno mjesto za vaš automobil",
  },
  {
    icon: "AirVent",
    title: "Klima uređaj",
    description: "Potpuna klimatizacija za ugodnu temperaturu",
  },
  {
    icon: "Waves",
    title: "Direktno na plaži",
    description: "Smještaj na samoj plaži s pristupom moru",
  },
  {
    icon: "Utensils",
    title: "Potpuno opremljena kuhinja",
    description: "Sve što vam treba za pripremu obroka",
  },
  {
    icon: "Tv",
    title: "Pogled na more",
    description: "Prekrasan pogled na Jadransko more s terase",
  },
];

// ============================================
// LOKACIJA
// ============================================
export const locationInfo = {
  address: "Borje 10",
  city: "Orebić",
  postalCode: "20250",
  country: "Hrvatska",
  description: "Apartmani se nalaze u mirnom mjestu Borje, u blizini Orebića na poluotoku Pelješcu. Prekrasne plaže smještene su nadomak apartmana, a do skrivenih, očaravajućih uvala možete stići SUP daskom (koju možete dobiti na upit). Na prekrasnim terasama apartmana možete uživati u jutarnjoj kavi ili večernjem pogledu na more, dok na plaži možete čitati knjigu u ugodnoj hladovini borova.\n\nDo Orebića vam je potrebno svega 8 minuta vožnje automobilom, a odatle za dodatnih 15 minuta brodicom stižete do Korčule. Ljubitelji prirode mogu uživati u nezaboravnom planinarenju do najvišeg vrha Pelješca, Sv. Ilije, ili se uputiti brodicom prema Nacionalnom parku Mljet i Parku prirode Lastovo.\n\nZa one željne aktivnog odmora i adrenalina, u blizini se nalazi i Viganj — pravi raj za surfere i jedno od najpoznatijih mjesta za windsurfing i kitesurfing na Jadranu. Dubrovnik je udaljen oko 80 minuta vožnje automobilom.\n\nIdealno za sve koji traže mir, prekrasan pogled na more i otoke te autentičan dalmatinski doživljaj, uz mogućnost sportskih avantura u blizini.",
  
  mapPlaceholder: false,
  // Google Maps embed URL za Borje 10, Orebić
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2932.8!2d17.1544!3d42.9789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x134a760f6e8d9c1d%3A0x8f3c2e7a9b6d4c5a!2sBorje%2010%2C%2020250%2C%20Orebi%C4%87%2C%20Croatia!5e0!3m2!1sen!2s!4v1699999999999!5m2!1sen!2s",
};

// ============================================
// ŠTA POSJETITI U BLIZINI
// ============================================
export const nearbyAttractions = [
  {
    id: 1,
    name: "Orebić",
    description: "Prekrasni dalmatinski gradić poznat po dugoj pomorskoj tradiciji, prekrasnim plažama i pogledu na Korčulu. Prošetajte rivom, posjetite Franjevački samostan ili uživajte u lokalnoj gastronomiji.",
    distance: "8 min vožnje",
    images: [
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/pmat5c29_Orebi%C4%87%201.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/5674r7uz_Orebi%C4%87%202.webp",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/1835tea1_Orebi%C4%87%203.jpg",
    ],
  },
  {
    id: 2,
    name: "Viganj",
    description: "Raj za surfere i ljubitelje vodenih sportova! Viganj je poznat kao jedna od najboljih europskih destinacija za windsurfing i kitesurfing zahvaljujući idealnim vjetrovima Maestralu.",
    distance: "15 min vožnje",
    images: [
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/5hmaosc8_Viganj%201.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/rjcmabi1_Viganj%202.webp",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/ty42ndqx_Viganj%203.jpg",
    ],
  },
  {
    id: 3,
    name: "Korčula",
    description: "\"Mali Dubrovnik\" - srednjovjekovni grad okružen zidinama, rodno mjesto Marka Pola. Istražite uske uličice, katedrale i uživajte u večernjoj atmosferi uz more.",
    distance: "15 min brodicom iz Orebića",
    images: [
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/icdeo2i5_Kor%C4%8Dula%201.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/h8r8h372_Kor%C4%8Dula%202.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/useodas3_Kor%C4%8Dula%203.jpg",
    ],
  },
  {
    id: 4,
    name: "Nacionalni park Mljet",
    description: "Najzeleniji hrvatski otok s dva slana jezera, benediktinskim samostanom na otočiću i netaknutom prirodom. Idealno za kupanje, vožnju kajakom i uživanje u miru.",
    distance: "1h brodicom",
    images: [
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/gxw0ahkf_Mljet%201.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/cabglli0_Mljet%202.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/29t6cx4r_Mljet%203.jpg",
    ],
  },
  {
    id: 5,
    name: "Sv. Ilija - najviši vrh Pelješca",
    description: "Nezaboravno planinarenje do vrha na 961m s panoramskim pogledom na cijeli poluotok, otoke i Jadransko more. Staza kreće iz Orebića kroz borovu šumu.",
    distance: "2h planinarenja iz Orebića",
    images: [
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/aekbn5cg_Sv.%20Ilija%201.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/w4j3j9iv_Sv%20Ilija%202.jpg",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/m8a3z3jv_Sv.%20ilija%203.jpg",
    ],
  },
  {
    id: 6,
    name: "Dubrovnik",
    description: "Biser Jadrana i UNESCO-va svjetska baština. Prošetajte poznatim zidinama, istražite Stradun, posjetite tvrđavu Lovrijenac ili se osvježite na plaži Banje. Nezaobilazna destinacija!",
    distance: "80 min vožnje",
    images: [
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/zzifk7aq_Dubrovnik%201.webp",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/xcin0yk6_Dubrovnik%202.webp",
      "https://customer-assets.emergentagent.com/job_beach-rental-4/artifacts/5e9ijan4_Dubrovnik%203.jpg",
    ],
  },
];

// ============================================
// FAQ - ČESTO POSTAVLJANA PITANJA
// ============================================
export const faqItems = [
  {
    question: "Kada je vrijeme dolaska i odlaska?",
    answer: "Check-in je od 14:00 do 23:00 sata. Check-out je od 06:00 do 11:00 sati. Molimo javite nam unaprijed kada planirate doći.",
  },
  {
    question: "Može li se doći s kućnim ljubimcem?",
    answer: "Nažalost, kućni ljubimci nisu dozvoljeni u apartmanu.",
  },
  {
    question: "Ima li apartman parking?",
    answer: "Da, apartman ima osigurano besplatno parkirno mjesto za goste.",
  },
  {
    question: "Je li dopušteno pušenje?",
    answer: "Pušenje nije dozvoljeno u apartmanu. Možete pušiti na vanjskoj terasi.",
  },
];

// ============================================
// KONTAKT INFORMACIJE
// ============================================
export const contactInfo = {
  phone: "+387 63 894 069",
  
  email: "janecek_i@hotmail.com",
  
  whatsapp: "38763894069",
};

// ============================================
// SEO METADATA
// ============================================
export const seoData = {
  title: "Apartmani Adriatic i Maestral | Smještaj na plaži u blizini Orebića i Korčule",
  description: "Apartmani Adriatic i Maestral nude smještaj direktno na plaži u blizini Orebića i Korčule s pogledom na more. Besplatni WiFi, parking, klima, terasa. Rezervirajte odmor iz snova!",
};

// ============================================
// STORAGE KEY ZA UPITE
// ============================================
export const STORAGE_KEY = "apartment_inquiries";
